import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '../api';
import { User } from '../../../models/user.model';
import { api } from '../../../models/api-url.model';
import type { ContactUpdatePayload } from './contact.types';

@Injectable({
  providedIn: 'root',
})
export class ContactService {
  private readonly apiService = inject(ApiService);

  getContacts(): Observable<User[]> {
    return this.apiService.get(api.contactsURL);
  }

  getLoggedInContact(): Observable<User> {
    return this.apiService.get(api.loggedInContactURL);
  }

  /** @deprecated */
  updateContact(userPayload: ContactUpdatePayload): Observable<unknown> {
    return this.apiService.post(api.contactsURL, userPayload);
  }

  getContactByOktaUsernameAndEmail(
    email: string,
    username: string,
  ): Observable<Partial<User>> {
    return this.apiService.get(this.buildOktaContactPath(email, username));
  }

  private buildOktaContactPath(email: string, username: string): string {
    return `${api.oktaContactURL}/${email}/${username}`;
  }
}
